module.exports = __webpack_public_path__ + "media/customizations/kalaiola/logo-new-704d5b33909049027a1c4d0745dc8833.png";